module.exports = __webpack_public_path__ + "h5/img/bs_07.c97de202.jpeg";